module.exports = __webpack_public_path__ + "img/20190722164823672.af877113.png";